import { Injectable } from '@angular/core';
import { StarRatingConfigService } from 'angular-star-rating';

@Injectable({
    providedIn: 'root'
})

export class CustomStarsService extends StarRatingConfigService {

    constructor() {
        super();
        this.numOfStars = 5;
        // this.staticColor = 'positive';
    }
}
